import React, { useState, useEffect } from "react";
import { Flex, Text, Box, Tooltip, useColorModeValue } from "@chakra-ui/react";
import NepaliDate from "nepali-date-converter";

const NepaliDateTime = () => {
    const [nepaliDateTime, setNepaliDateTime] = useState("");

    useEffect(() => {
        const updateDateTime = () => {
            const currentDate = new Date();
            const nepaliDate = new NepaliDate(currentDate);
            const formattedDateTime = nepaliDate.format("dddd, DD MMMM, YYYY");
            setNepaliDateTime(formattedDateTime);
        };

        updateDateTime();
        const interval = setInterval(updateDateTime, 1000); // Update every second
        return () => clearInterval(interval);
    }, []);

    return (
        <Flex
            direction="row"
            align="center"
            justify="space-between"
            p={2}
            bg={useColorModeValue("gray.100", "gray.800")}
            rounded="md"
            shadow="md"
        >
            <Tooltip label="Nepali Date & Time" aria-label="Nepali Date Tooltip">
                <Text
                    fontSize="lg"
                    fontWeight="bold"
                    color={useColorModeValue("blue.600", "blue.300")}
                    noOfLines={1}
                >
                    {nepaliDateTime}
                </Text>
            </Tooltip>
        </Flex>
    );
};

export default NepaliDateTime;